












































import { Component, Prop, Watch } from 'vue-property-decorator'

import { errorNotificationWrapper } from '../../../../../../../../../logic/helpers/NotificationService'
import { ChannelLimitedTypeEnum } from '../../../../../../../../../shared/types/Channel'
import ChannelSubscriptionInfo from '../../../../../../../../ChannelSubscriptionInfo/ChannelSubscriptionInfo.vue'
import { UseFields } from '../../../../../../../../Pi'
import { FieldData } from '../../../../../../../../Pi/types'
import CustomEditor from '../../../../../Editor/CustomEditor'
import { CreateLimitedSubscriptionNode } from '../../logic/CreateLimitedSubscription'

@Component({
  components: { ChannelSubscriptionInfo }
})
export default class CreateLimitedSubscriptionSidebar extends UseFields {
  @Prop() node!: CreateLimitedSubscriptionNode

  @Prop() editor!: CustomEditor

  loadChannelType = false

  channelType: null | ChannelLimitedTypeEnum = null

  @Watch('currentChannel')
  async currentChannelWatcher(channel?: { id: number, login: string, title: string }): Promise<void> {
    if (channel) {
      this.getChannelInfo(channel.id)
    } else {
      this.channelType = null
    }
  }

  async getChannelInfo(channelId:number) {
    try {
      this.loadChannelType = true
      this.channelType = await this.node.nodeProps.getChannelSubscriptionType(channelId)
    } catch (e) {
      errorNotificationWrapper(this.$t('error').toString(), e)
      this.channelType = null
    } finally {
      this.loadChannelType = false
    }
  }

  get currentChannel() {
    return this.node.nodeProps.targets().find((t) => t.id === this.node.data.target)
  }

  get targets(): Array<{ label: string, value: number }> {
    return this.node.nodeProps.targets()
      .map((target) => {
        return {
          label: target.title,
          value: target.id
        }
      })
  }

  goToSubscriptionSettings(): void {
    if (this.currentChannel) {
      window.open(this.node.nodeProps.getChannelSubscriptionLink(this.currentChannel.id), '_blank')
    }
  }

  setTarget(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setTarget(val)
    return arg
  }

  setOffset(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setOffset(val)
    return arg
  }

  mounted() {
    const target = this.node.data.target

    if (target) {
      this.getChannelInfo(target)
    }
  }
}
